<template>
  <v-row class="mx-2">
    <v-col :style="{ 'padding-left': padding }">
      <v-col
        cols="12"
        md="8"
        sm="6"
        xs="4"
        style="max-width: 1500px"
        class="d-flex justify-space-between mx-auto"
      >
        <v-btn color="info" text class="my-auto pl-0" @click="goToElements">
          <v-img
            src="@/assets/icons/anterior.png"
            style="cursor: pointer"
            alt="anterior"
            max-width="30"
            max-height="30"
            dark
          />Elementos
        </v-btn>
        <ButtonsCardList @cardView="cardView" />
      </v-col>
      <div v-if="showCard">
        <CardsView
          :items="dfis"
          :title="title"
          :showEdit="false"
          :showDelete="false"
          :showAdd="false"
        />
      </div>
      <div v-else>
        <TableWithSearch
          :items="dfis"
          :headers="allHeaders"
          :title="title"
          @headersUpdated="updateHeaders"
          :showAdd="false"
        />
      </div>
    </v-col>

    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
  </v-row>
</template>
<script>
import schedules from "../../../store/permisosDeAcceso/accessPermissions";
import CardsView from "@/components/Complement/CardsView.vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";
import Loader from "@/components/Complement/Loader.vue";
export default {
  components: {
    CardsView,
    TableWithSearch,
    ButtonsCardList,
    Loader,
  },

  data() {
    return {
      showCard: true,
      title: "DFis",
      titleTable: "PermisosDeAcceso_dfis",
      titleDelete: this.$tc("schedules.toElement"),
      color: "",
      alert: false,
      textAlert: "",
      isLoading: true,
      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Alias",
          value: "alias",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Descripcion",
          value: "description",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Require Cacheo",
          value: "requiredCacheoIcon",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Porcentaje Cacheo",
          value: "porcentCacheo",
          class: "primary secondary--text",
          visible: true,
        },

        {
          text: "Require Pin",
          value: "requiredPinIcon",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Require PassBack",
          value: "requiredPassBackIcon",
          class: "primary secondary--text",
          visible: true,
        },
      ],
    };
  },
  mounted() {
    this.isLoading = true; // Set loading to true at the start
    schedules
      .dispatch("getDfis")
      .then(() => {
        this.isLoading = false; // Set loading to false if the request is successful
      })
      .catch((error) => {
        console.error("An error occurred:", error);
        this.isLoading = false; // Set loading to false even if there's an error
        // You can handle the error further here if needed
      });
      configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (configTable.state.colums.length === 0 || configTable.state.colums.length !== this.headers.length ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
  },

  computed: {
    allHeaders() {
      return configTable.state.colums;
    },
    padding() {
      return schedules.state.paddingNav;
    },
    dfis() {
      return schedules.state.dfis;
    },
  },

  methods: {
    goToElements() {
      schedules.dispatch("handleShowWindow", "element");
    },
    cardView(value) {
      this.showCard = value;
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
  },
};
</script>
<style scoped></style>
